module.exports = __webpack_public_path__ + "img/toprfjc_bg.0b4b5f9f.png";